import React from "react";

import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavbarBrand from "react-bootstrap/NavbarBrand";

import classNames from "classnames";
import { isEmpty } from "lodash";
import { Link, useMatch } from "react-router-dom";
import { ReactSVG } from "react-svg";

import { UserStatus } from "@api/graphql";
import logo from "@assets/rrs-logo.svg";
import { IconNavLink } from "@components/IconNavLink";
import { useIsAuthorisedUser } from "@components/permission_control/ProtectedComponent";
import { navItems } from "@pages/dashboard/NavItems";
import NavToggle from "@pages/dashboard/NavToggle";
import { Role } from "@roles";
import { isNullOrUndefined } from "@util/index";

import { ROUTES } from "../../routes";

import styles from "./DashboardNav.module.scss";

interface NavItemProps {
  to: string;
  groups?: Role[];
  user_status?: UserStatus;
  text: string;
  icon: string;
}

const NavItem = ({ to, groups, user_status, text, icon }: NavItemProps) => {
  const isAuthorisedUser = useIsAuthorisedUser({
    requiredGroups: groups,
  });

  const isActiveUser = useIsAuthorisedUser({
    requiredUserStatus: UserStatus.ACTIVE,
  });
  const requireActive = user_status === UserStatus.ACTIVE || isEmpty(user_status);
  const iconComponent = (
    <IconNavLink
      isActive={!isNullOrUndefined(useMatch(to))}
      to={to}
      src={icon}
      text={text}
      isDisable={!(requireActive && isActiveUser)}
    />
  );
  if (groups?.length && !isAuthorisedUser) {
    return <></>;
  }

  return iconComponent;
};

interface DashboardNavProps {
  isSelectedReport: boolean;
  setIsSelectedReport: (selected: boolean) => void;
  isReporter: boolean;
  isRecipient: boolean;
}

export const DashboardNav = ({ isSelectedReport, setIsSelectedReport, isReporter, isRecipient }: DashboardNavProps) => {
  const filteredNavItems = navItems.filter((item) =>
    isReporter && isRecipient
      ? isSelectedReport
        ? item.groups?.includes(Role.ResaleReporter)
        : item.groups?.includes(Role.RoyaltyRecipient)
      : true,
  );

  return (
    <Navbar className={classNames(styles["dashboard-nav"], "d-flex flex-column w-100")} expand="sm">
      <NavbarBrand as={Link} to={ROUTES.Root.path} className={classNames(styles["logo"], "d-flex flex-column")}>
        <ReactSVG src={logo} />
      </NavbarBrand>
      {/* Only show NavToggle if both roles exist for art centre*/}
      {isReporter && isRecipient && <NavToggle isReportActive={isSelectedReport} onToggle={setIsSelectedReport} />}
      <Nav className="d-flex flex-column gap-2">
        {filteredNavItems.map((item) => (
          <NavItem key={item.to} {...item} />
        ))}
      </Nav>
    </Navbar>
  );
};
